import { FC, useContext, useState } from "react";
import { TeamContext } from "../../../context";

interface ITipping {
    solutionCardUserEmail: string;
}

const Tipping : FC<ITipping> = ({solutionCardUserEmail}) => {
    const { game } = useContext(TeamContext);
    const [isHovered, setIsHovered] = useState<boolean>(false);
    var usersWhoTippedMeEmails : string[] = [];
    const tippingLinst = game?.gameInfo.players[solutionCardUserEmail]?.tipped;
    for (var key in tippingLinst) if (tippingLinst[key]) usersWhoTippedMeEmails.push(key);

    const getListOfUsersWhoLikedThisPhoto = (userWhoTippedMeEmail: any, index: number) => {
        const userLikeImageVisibility = index > 1 ? "none" : "inline";
        
        return (
            <div key={index} className="proposed_solution_cards_full_screen_tipping_list_of_users" style={{display: userLikeImageVisibility}}> 
                <img className={`users_like_list_picture  border_color_pink `} src={`${process.env.REACT_APP_BACKEND_URL}images/${userWhoTippedMeEmail}.png`} alt="Profile Icon" />
            </div> 
        )
    }

    const getBoxWithListOfUsersWhoLikedThisPhoto = (userWhoTippedMeEmail: any, index: number) => {
        return (
            <div key={index}  className="proposed_solution_cards_full_screen_tipping_list_of_users_hover_row">
                <img className={`users_like_list_picture  border_color_pink `} src={`${process.env.REACT_APP_BACKEND_URL}images/${userWhoTippedMeEmail}.png`} alt="Profile Icon" />
                <div className="user_like_list_name"> {game?.players.find( (item: any) => item.email === userWhoTippedMeEmail )?.nickname} </div>
            </div>
        )
    }

    if (!usersWhoTippedMeEmails.length) return <div></div>;

    return (
        <div className="proposed_solution_cards_full_screen_tipping_list_of_users_wrapper" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            {usersWhoTippedMeEmails.map( (user, index) => { return getListOfUsersWhoLikedThisPhoto(user, index) })}
            {isHovered && <div className="proposed_solution_cards_full_screen_tipping_list_of_users_hover">
                {usersWhoTippedMeEmails.map( (user, index) => { return getBoxWithListOfUsersWhoLikedThisPhoto(user, index) })}
            </div>}
            {usersWhoTippedMeEmails.length > 2 && <div> ... </div>}
        </div>
    )
}

export default Tipping;